export const mobileBreakpoint = "768px";
export const mdBreakpoint = "1024px";
